import { closingStatusToNumber } from '../constants';
import type { ClosingStatus } from '../types';

export function isWonClosingStatus(value: ClosingStatus | null | undefined): boolean {
  return closingStatusToNumber(value ?? null) === 2;
}

export function isLostClosingStatus(value: ClosingStatus | null | undefined): boolean {
  return closingStatusToNumber(value ?? null) === 3;
}

export function closeLeadModalTitle(value: ClosingStatus | null | undefined): string {
  if (isWonClosingStatus(value)) {
    return 'Close as Won';
  }

  if (isLostClosingStatus(value)) {
    return 'Close as Lost';
  }

  if (closingStatusToNumber(value ?? null) === 4) {
    return 'Close as Disqualified';
  }

  return 'Close Lead';
}
